import script from "./DropWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./DropWizard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SecondaryNav from "@/components/SecondaryNav.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardConfirmModal from "@/components/neue/wizard/WizardConfirmModal.vue";
import WizardNav from "@/components/neue/wizard/WizardNav.vue";
import WizardRail from "@/components/neue/wizard/WizardRail.vue";
script.components = Object.assign({}, { SecondaryNav, WizardButton, WizardConfirmModal, WizardNav, WizardRail }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SecondaryNav, WizardButton, WizardConfirmModal, WizardNav, WizardRail }, script.__o.components);}